
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class RichTextToggle extends Vue {
  @Prop({ required: true })
  private readonly content!: string;

  @Prop({ default: 5 })
  private readonly showlines!: number;

  private toggled = false;

  countLines(): number {
    return this.content!.split('</p>').length;
  }

  toggle() {
    this.toggled = !this.toggled;
  }
}
